import { Block } from 'baseui/block';
import { Radio as DefaultRadio } from 'baseui/radio';
import extend from 'lodash/extend';
import { styled } from 'baseui';
import * as React from 'react';
const RadioLabel = styled(Block, {
  margin: '0 10px 0 5px'
});
type RadioT = {
  children: React.ReactNode;
  overrides?: any;
};
const Radio = ({
  children,
  overrides,
  ...props
}: RadioT) => {
  return <DefaultRadio overrides={extend(overrides, {
    Label: RadioLabel
  })} {...props}>
      {children}
    </DefaultRadio>;
};
export default Radio;